import { PageLinkModel } from "@insite/client-framework/Services/ContentService";
import { GetInvoicesApiParameter } from "@insite/client-framework/Services/InvoiceService";
import { GetOrdersApiParameter } from "@insite/client-framework/Services/OrderService";
import { usePageLinkByPageType } from "@toolkit/Framework/Store/Links/LinksHooks";
import qs from "qs";

const useLinkBackParameter = (pageTpe: string, parameter: GetInvoicesApiParameter | GetOrdersApiParameter) => {
    let linkBack = usePageLinkByPageType(pageTpe);
    const queryString = qs.stringify(parameter);
    const urlPageBack = `${linkBack?.url}${queryString !== "" ? `?${queryString}` : ""}`;
    linkBack = { ...linkBack, url: urlPageBack } as PageLinkModel;

    return linkBack;
};

export default useLinkBackParameter;
